import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiAccount, mdiEmail, mdiLock } from "@mdi/js";
import "../App.css";
import "../css/skin-modes.css";
import "../css/custom.css";
import loader from "../images/loader.svg";
import headerImage from "../images/brand/logo6654.png?v1";
import Captcha from "../components/Captcha";

function Register() {
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ login: "", tg_username: "", jabber: "", password: "", captcha: "" });
  const [formError, setFormError] = useState(false);
  const [captchaError, setCaptchaError] = useState(false);
  const captchaRef = React.useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate loader
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div id="global-loader">
        <img src={loader} className="loader-img" alt="Loader" />
        <style>{`
          #global-loader {
            position: fixed;
            z-index: 50000;
            background: rgb(255, 255, 255);
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            height: 100vh;
            width: 100%;
            margin: 0 auto;
            text-align: center;
          }
          .loader-img {
            position: absolute;
            right: 0;
            bottom: 0;
            top: 43%;
            left: 0;
            margin: 0 auto;
            text-align: center;
          }
        `}</style>
      </div>
    );
  }

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError(false);

    const { login, password, captcha } = form;
    if (!login.trim() || !password.trim() || !captcha.trim()) {
      setFormError(true);
      return;
    }

    if (!captchaRef.current.verify()) {
      setCaptchaError(true);
      setForm({ ...form, captcha: "" });
      return;
    }

    sessionStorage.setItem("register_username", login);
    sessionStorage.setItem("register_password", password);
    sessionStorage.setItem("register_telegram", form.tg_username);
    sessionStorage.setItem("register_jabber", form.jabber);

    navigate("/protects");
  };

  return (
    <div className="page">
      <div>
        <div className="col col-login mx-auto text-center">
          <Link to="/"><img src={headerImage} className="header-brand-img" alt="" /></Link>
        </div>
        <div className="container-login100">
          <div className="wrap-login100 p-0">
            <div className="card-body">
              <form className="login100-form validate-form" onSubmit={handleSubmit}>
                <span className="login100-form-title">Registration</span>
                <div className="wrap-input100 validate-input" data-bs-validate="Valid login is required">
                  <input className="input100" type="text" name="login" value={form.login} onChange={handleChange} required placeholder="Login" />
                  <span className="focus-input100"></span>
                  <span className="symbol-input100">
                    <Icon path={mdiAccount} size={0.7} aria-hidden="true" />
                  </span>
                </div>
                <div className="wrap-input100 validate-input">
                  <input className="input100" type="text" name="tg_username" value={form.tg_username} onChange={handleChange} placeholder="Telegram" />
                  <span className="focus-input100"></span>
                  <span className="symbol-input100">
                    <Icon path={mdiEmail} size={0.7} aria-hidden="true" />
                  </span>
                </div>
                <div className="wrap-input100 validate-input">
                  <input className="input100" type="text" name="jabber" value={form.jabber} onChange={handleChange} placeholder="Jabber" />
                  <span className="focus-input100"></span>
                  <span className="symbol-input100">
                    <Icon path={mdiEmail} size={0.7} aria-hidden="true" />
                  </span>
                </div>
                <div className="wrap-input100 validate-input" data-bs-validate="Password is required">
                  <input className="input100" type="password" name="password" value={form.password} onChange={handleChange} placeholder="Password" />
                  <span className="focus-input100"></span>
                  <span className="symbol-input100">
                    <Icon path={mdiLock} size={0.7} aria-hidden="true" />
                  </span>
                </div>
                {formError && (
                  <div className="invalid-feedback" style={{ display: "block", width: "100%", marginTop: "0.25rem", fontSize: "87.5%", color: "#d12c47" }}>
                    <strong>Please fill out all required fields.</strong>
                  </div>
                )}
                <label className="custom-control custom-checkbox mt-4">
                  <input type="checkbox" name="terms" value="1" className="custom-control-input" required />
                  <span className="custom-control-label">
                    Agree the <a target="_blank" rel="noopener noreferrer" href="/rules.html">terms and policy</a>
                  </span>
                </label>
                <div className="form-group">
                  <div className="main-parent">
                    <input className="form-control form-control-lg" name="captcha" value={form.captcha} onChange={handleChange} placeholder="Captcha" type="text" required />
                    <div className="d-flex main-child">
                      <Captcha ref={captchaRef} answer={form.captcha} onVerify={setCaptchaError} type="alphabet" />
                    </div>
                  </div>
                </div>
                {captchaError && (
                  <div className="invalid-feedback" style={{ display: "block", width: "100%", marginTop: "0.25rem", fontSize: "87.5%", color: "#d12c47" }}>
                    <strong>Invalid Captcha</strong>
                  </div>
                )}
                <div className="container-login100-form-btn">
                  <button type="submit" className="login100-form-btn btn-primary">
                    Register
                  </button>
                </div>
                <div className="text-center pt-3">
                  <p className="text-dark mb-0">
                    Already have account?
                    <Link to="/" className="text-primary ms-1">
                      Sign In
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .btn-primary:hover {
          color: var(--primary-bg-color) !important;
        }
      `}</style>
    </div>
  );
}

export default Register;
